import React from "react";
import Presenter from "./Presenter";

export default ({ config }) => <Presenter config={config} />;
